// Copyright (C) 2026 TANNER AG

import React from "react";
import Chip from "@mui/material/Chip";
import { SxProps, Theme } from "@mui/material/styles";
import useTranslation from "../hooks/usetranslation";

type Props = {
    // Derived in appservice from groupColor = Blue. Tag renders only when true.
    isPreview?: boolean | null;
    // Absolute top-left overlay for cards/thumbnails; inline chip otherwise.
    overlay?: boolean;
    sx?: SxProps<Theme>;
};

const overlaySx: SxProps<Theme> = {
    position: "absolute",
    top: 8,
    left: 8,
    zIndex: 2
};

// MAN-red status chip. Non-interactive (distinct from the interactive filter TagList).
const PreviewTag: React.FC<Props> = ({ isPreview, overlay = false, sx }) => {
    const { t } = useTranslation();

    if (!isPreview) {
        return null;
    }

    return (
        <Chip
            label={t("preview")}
            size="small"
            aria-label={t("preview")}
            sx={{
                backgroundColor: "secondary.main",
                color: "#fff",
                fontSize: "16px",
                fontWeight: 700,
                textTransform: "none",
                ...(overlay ? overlaySx : {}),
                ...sx
            }}
        />
    );
};

export default PreviewTag;
